







































import {Emit, Prop} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Commande, Fournisseur} from '@/models';

import CrudCommandeEdit from '@/components/Crud/Commande/Edit.vue';

@Component({
	components: {
		CrudCommandeEdit,
	}
})
export default class CrudCommandeEditDialog extends Vue {
	@InOut({ type: Commande  , isVModel: true }) private value!: Commande;

	@Emit()
	private onSubmit(commande: Commande) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}

	public mounted() {
	}
}
